import { CommonModule } from "@angular/common";
import { SharedModule } from "../../../core/shared/shared.module";
import { NgModule } from "@angular/core";
import { usersListRouting } from "./users-list.routing";
import { UsersListComponent } from "./users-list.component";
import { UsersListRest } from "./users-list.rest";
import { LoginRest } from "../../../login/login.rest";

@NgModule({
    imports: [
      CommonModule,
      usersListRouting,
      SharedModule,
    ],  
    declarations: [UsersListComponent],
    exports: [],
    providers : [UsersListRest, LoginRest]
  })
  export class UsersListModule { }